import { api } from "../api";

/**
 * userFindAllSecretariesListResponse - Function that finds on database all secretaries allowed per user as select list response   
 * /users/{id}/secretaries/list  
 * method GET 
 * @async-function
 */
const userFindAllSecretariesListResponse = async (token: string, id: number) => {
    const response = await api.get(
        `/users/${id}/secretaries/list`, {
        headers: {
            'Authorization': `Bearer ${token}`
        },
    }
    );
    return response;
};

export default userFindAllSecretariesListResponse;